<form [formGroup]="form" (ngSubmit)="onSubmit(form)" class="container">
    <div formGroupName="data">
        <div class="info">
            <div class="form1">
                <span class="input">
                    <mat-form-field style="width: 150px;">
                        <mat-label>LMP</mat-label>
                        <input formControlName="lmp" matInput placeholder="">
                    </mat-form-field>
                </span>
                <span class="input">
                    <mat-form-field style="width: 150px;">
                        <mat-label>G.A (LMP)</mat-label>
                        <input formControlName="ga" matInput placeholder="">
                    </mat-form-field>
                </span>
                <span class="input">
                    <mat-form-field style="width: 150px;">
                        <mat-label>EDD (LMP)</mat-label>
                        <input formControlName="edd" matInput placeholder="">
                    </mat-form-field>
                </span>
                <span class="input">
                    <mat-form-field style="width: 150px;">
                        <mat-label>Date</mat-label>
                        <input matInput [matDatepicker]="dob" (dateChange)="DateChange($event)">
                        <mat-datepicker-toggle matSuffix [for]="dob"></mat-datepicker-toggle>
                        <mat-datepicker #dob></mat-datepicker>
                    </mat-form-field>
                </span>
            </div>

            <div class="img">
                <div class="imgBox">
                    <img *ngIf="fullImage" [src]="fullImage" style="width: 100%; height: 100%;" alt="">
                </div>
                <div class="sel">
                     <span class="input">
                        <mat-form-field style="width: 150px;">
                        <mat-label>Images</mat-label>
                        <mat-select matNativeControl (selectionChange)="slectOnChange1($event)">
                            <mat-option *ngFor="let data of image1" [value]="data.OptionValue">{{data.OptionName}}</mat-option>
                        </mat-select>
                        </mat-form-field>
                    </span>
                    <span class="input">
                        <mat-form-field style="width: 150px;">
                        <mat-label>Images</mat-label>
                        <mat-select matNativeControl (selectionChange)="slectOnChange($event)" [disabled]="disabled">
                            <mat-option *ngFor="let data of image2" [value]="data.OptionValue">{{data.OptionName}}</mat-option>
                        </mat-select>
                        </mat-form-field>
                    </span>
                </div>
            </div>

        </div> <br>
        <mat-divider style="margin-bottom: 30px;"></mat-divider>
        <div class="form">
            <div class="left">
                <span class="input">
                    <mat-form-field>
                    <mat-label>No. of Fetus(es)</mat-label>
                    <input type="text" matInput formControlName="no_of_fetus" [matAutocomplete]="auto" />
                        <mat-autocomplete #auto="matAutocomplete">
                          <mat-option *ngFor="let option of NoofFetus" [value]="option.OptionValue">
                            {{option.OptionName}}
                          </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </span>
                <span class="input">
                    <mat-form-field>
                    <mat-label>Fetal Heart Beat</mat-label>
                    <input type="text" matInput formControlName="fetal_heart_beat" [matAutocomplete]="auto2" />
                    <mat-autocomplete #auto2="matAutocomplete">
                      <mat-option *ngFor="let option of FetalHeartBeat" [value]="option.OptionValue">
                        {{option.OptionName}}
                      </mat-option>
                    </mat-autocomplete>
                    </mat-form-field>
                </span>
                <span class="input">
                    <mat-form-field>
                    <mat-label>Presentation</mat-label>
                    <input type="text" matInput formControlName="presentation" [matAutocomplete]="auto20" />
                    <mat-autocomplete #auto20="matAutocomplete">
                      <mat-option *ngFor="let option of Presentation" [value]="option.OptionValue">
                        {{option.OptionName}}
                      </mat-option>
                    </mat-autocomplete>
                    </mat-form-field>
                </span>
                <span class="input">
                    <mat-form-field>
                        <mat-label>Fetal lie (mm)</mat-label>
                        <input type="text" matInput formControlName="fetus_lie" [matAutocomplete]="auto21" />
                        <mat-autocomplete #auto21="matAutocomplete">
                          <mat-option *ngFor="let option of fetalLie" [value]="option.OptionValue">
                            {{option.OptionName}}
                          </mat-option>
                        </mat-autocomplete>
                    </mat-form-field>
                </span>
                <span class="input">
                    <mat-form-field>
                        <mat-label>B.P.D (mm)</mat-label>
                        <input formControlName="bpd" matInput placeholder="">
                    </mat-form-field>
                </span>
                <span class="input">
                    <mat-form-field>
                        <mat-label>F.L (mm)</mat-label>
                        <input formControlName="fl" matInput placeholder="">
                    </mat-form-field>
                </span>
                <span class="input">
                    <mat-form-field>
                        <mat-label>A.C (mm)</mat-label>
                        <input formControlName="ac" matInput placeholder="">
                    </mat-form-field>
                </span>
                <span class="input">
                    <mat-form-field>
                        <mat-label>H.C (mm)</mat-label>
                        <input formControlName="hc" matInput placeholder="">
                    </mat-form-field>
                </span>
                <span class="input">
                    <mat-form-field>
                        <mat-label>Estim. Fetal Weight (kg)</mat-label>
                        <input formControlName="fet_weg" matInput placeholder="">
                    </mat-form-field>
                </span>
                <span class="input">
                    <mat-form-field>
                    <mat-label>Dr.</mat-label>
                    <mat-select formControlName="doctor_id" matNativeControl>
                        <mat-option *ngFor="let dr of drs" [value]="dr.id">{{dr.name}}</mat-option>
                    </mat-select>
                    </mat-form-field>
                </span>
            </div>


            <div class="right">
                <fieldset class="size">
                    <legend>Fetus</legend>
                <div class="input">
                    <label class="example-margin" style="margin-left: 0; margin-right: 50px; margin-top: 40px;">Fetus:</label>
                    <mat-radio-group class="pos" [(ngModel)]="fetus" (change)="changeFetus($event)" [ngModelOptions]="{standalone: true}">
                        <mat-radio-button color="primary" class="example-margin" value="A">FetusA</mat-radio-button>
                        <mat-radio-button color="primary" class="example-margin" value="B">FetusB</mat-radio-button>
                        <mat-radio-button color="primary" class="example-margin" value="C">FetusC</mat-radio-button>
                    </mat-radio-group>
                </div>
                </fieldset>
                <span class="input">
                  <mat-form-field>
                  <mat-label>Gender</mat-label>
                  <input type="text" matInput formControlName="gender" [matAutocomplete]="auto84" />
                    <mat-autocomplete #auto84="matAutocomplete">
                      <mat-option *ngFor="let data of gender" [value]="data.OptionValue">
                        {{data.OptionName}}
                      </mat-option>
                    </mat-autocomplete>
                  </mat-form-field>
              </span>
                <span class="input">
                    <mat-form-field>
                        <mat-label>USS Average G.A</mat-label>
                        <input formControlName="us_average" matInput placeholder="">
                    </mat-form-field>
                </span>
                <span class="input">
                    <mat-form-field>
                        <mat-label>USS EDD</mat-label>
                        <input formControlName="us_edd" matInput placeholder="">
                    </mat-form-field>
                </span>
                <span class="input">
                    <mat-form-field>
                    <mat-label>Placenta Location (Anatomic)</mat-label>
                    <input type="text" matInput formControlName="P_location_ana" [matAutocomplete]="auto24" />
                      <mat-autocomplete #auto24="matAutocomplete">
                        <mat-option *ngFor="let option of PlacentaLocationAnatomic" [value]="option.OptionValue">
                          {{option.OptionName}}
                        </mat-option>
                      </mat-autocomplete>
                    </mat-form-field>
                </span>
                <span class="input">
                    <mat-form-field>
                    <mat-label>Placenta Location</mat-label>
                    <input type="text" matInput formControlName="p_location" [matAutocomplete]="auto25" />
                    <mat-autocomplete #auto25="matAutocomplete">
                      <mat-option *ngFor="let option of PlacentaLocation" [value]="option.OptionValue">
                        {{option.OptionName}}
                      </mat-option>
                    </mat-autocomplete>
                    </mat-form-field>
                </span>
                <span class="input">
                    <mat-form-field>
                    <mat-label>Anatomic Fluid</mat-label>
                    <input type="text" matInput formControlName="amniotic_fluid" [matAutocomplete]="auto26" />
                    <mat-autocomplete #auto26="matAutocomplete">
                      <mat-option *ngFor="let option of AmnioticFluid" [value]="option.OptionValue">
                        {{option.OptionName}}
                      </mat-option>
                    </mat-autocomplete>
                    </mat-form-field>
                </span>
                <span class="input">
                    <mat-form-field>
                    <mat-label>Fetal Anomaly</mat-label>
                    <input type="text" matInput formControlName="fet" [matAutocomplete]="auto27" />
                    <mat-autocomplete #auto27="matAutocomplete">
                      <mat-option *ngFor="let option of FetalAnomaly" [value]="option.OptionValue">
                        {{option.OptionName}}
                      </mat-option>
                    </mat-autocomplete>
                    </mat-form-field>
                </span>
                <span class="input">
                    <mat-form-field>
                    <mat-label>Cervical OS</mat-label>
                    <input type="text" matInput formControlName="cervical_os" [matAutocomplete]="auto28" />
                    <mat-autocomplete #auto28="matAutocomplete">
                      <mat-option *ngFor="let option of CervicalOs" [value]="option.OptionValue">
                        {{option.OptionName}}
                      </mat-option>
                    </mat-autocomplete>
                    </mat-form-field>
                </span>
            </div>
        </div>
        <div class="space"></div>
        <mat-divider style="margin-bottom: 30px;"></mat-divider>
            <div class="form">
                <div class="left">
                    <span class="input">
                        <mat-form-field>
                            <mat-label>Comments</mat-label>
                            <textarea formControlName="comments" matInput></textarea>
                        </mat-form-field>
                    </span>
                </div>

                <div class="right">
                </div>

            </div>

            <div class="button">
                <button (click)="add()" type="button" class="button" mat-raised-button color="primary"> Add</button>
                <a routerLink="/Result-entry" class="waves-effect">
                  <button type="button" style="margin-left: 20px;" class="button" mat-raised-button color="primary"> Cancel</button>
                </a>
                <button [disabled]="disable" type="submit" class="button" mat-raised-button color="primary" *ngIf="!isLoading"> Save</button>
                <button [disabled]="disable" type="submit" class="button" mat-raised-button color="primary" *ngIf="isLoading"><i class="fa fa-spinner fa-spin" aria-hidden="true"></i></button>
            </div>
        </div>

    </form>
